// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Outlet, useNavigate } from 'react-router-dom'
import { Leaf, LogOut } from 'lucide-react'
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { useSessionStore } from '@/store'
import { ROUTES } from '@/lib/constants/routes'

export function NextOfKinShell() {
  const navigate     = useNavigate()
  const { clearSession, userId } = useSessionStore()

  function handleEndSession() {
    clearSession()
    navigate(ROUTES.NEXT_OF_KIN_ENTRY)
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#faf8f4]">
      {/* Nabestaanden topbar - distinct warm variant */}
      <header className="flex items-center justify-between h-14 px-5 border-b border-[#e8e0d4] bg-white/80 backdrop-blur-sm sticky top-0 z-20">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-moss/90">
            <Leaf className="h-3.5 w-3.5 text-white" />
          </div>
          <div className="flex flex-col">
            <span className="text-xs text-ink-4 leading-none">U bekijkt de wensen van</span>
            <span className="text-sm font-medium text-ink leading-tight">
              {userId ? 'de overledene' : '-'}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-xs text-ink-4 bg-sand-200 rounded-full px-2.5 py-1">
            Alleen lezen
          </span>
          <button
            onClick={handleEndSession}
            className="flex items-center gap-1.5 text-xs text-ink-4 hover:text-ink-3 transition-colors"
          >
            <LogOut className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Sessie beëindigen</span>
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 mx-auto w-full max-w-[760px] px-4 py-6 sm:px-6">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}
